import MicroModal from "micromodal";
import { backfaceFixed } from "./backface-fixed";

const defaultOptions = {
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  disableFocus: true,
  disableScroll: true,
  debugMode: false,
  onShow: () => {
    backfaceFixed(true);
  },
  onClose: () => {
    backfaceFixed(false);
  },
};
const micromodal = (id, options = {}) => {
  const mergedOptions = Object.assign({}, defaultOptions, options);
  MicroModal.show(id, mergedOptions);
};

export { micromodal };
